exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-body {\n  margin-top: -5em;\n  margin-bottom: 2em; }\n  .login-body .login-panel {\n    background-color: #00632c !important; }\n    .login-body .login-panel input {\n      color: white;\n      font-size: 2rem; }\n    .login-body .login-panel label {\n      color: ghostwhite; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/home-module/login/login.component.scss
// module id = ../../../../../src/app/home-module/login/login.component.scss
// module chunks = main